export default "__VITE_ASSET__DO9h3c_T__"